import React from 'react';

const StarbeatNoticeKO = () => {
  return (
    <>
      <ul className='starbeat-notice-desc-group'>
        <li className='starbeat-notice-desc-list'>
          <p className='starbeat-notice-desc-title'>스타비트 이용 안내</p>
          <ul className='starbeat-notice-desc-depth2-group'>
            <li className='starbeat-notice-desc-depth2-list'>
              - 유료로 구입할 수 있는 비트로, 뮤빗 라이브 상품 구매 및 뮤빗 앱 내 광고 모금, 놀이터 등에 사용할 수
              있습니다.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 구매하신 스타비트는 웹, AOS 앱, iOS 앱 내에서 통합 사용이 가능합니다.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>- 유효기간: 적립일로부터 5년.</li>
          </ul>
        </li>
        <li className='starbeat-notice-desc-list'>
          <p className='starbeat-notice-desc-title'>구매 유의 사항</p>
          <ul className='starbeat-notice-desc-depth2-group'>
            <li className='starbeat-notice-desc-depth2-list'>- 스타비트 금액에는 부가가치세가 포함되어 있습니다.</li>
            <li className='starbeat-notice-desc-depth2-list'>- 스타비트 구매 시 세금이 국가별로 별도로 부과됩니다.</li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 미성년자가 법정 대리인의 동의 없이 결제 한 경우, 본인 또는 법정대리인은 결제 취소할 수 있습니다. 다만
              미성년자가 속임수로써 본인을 성년자로 믿게 하거나 법정대리인의 동의가 있는 것으로 믿게 한 경우에는 취소 할
              수 없습니다.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 동일한 사유 또는 유형의 스타비트 철회/환불을 반복적으로 요청하거나 정당하지 않은 사유로 철회/환불을
              지속하는 경우 서비스 이용에 제약이 있을 수 있습니다.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 스타비트를 구매한 지 7일(청약 철회 기간) 이내만 환불신청이 가능합니다.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 유료 결제 후 사용하지 않은 스타비트는 구매일 기준 7일 내 환불신청이 가능합니다.
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 뮤빗 앱 &gt; 설정 &gt; 이메일로 문의하기 또는 support@mubeat.tv로 이메일을 통해 직접 환불 신청하실 수
              있습니다. 하단 양식을 지켜서 문의해 주시기 바랍니다.
              <br />
              &lt;신청 양식&gt;
              <br />
              제목: [WEB 구매 스타비트 환불 문의]
              <br />
              내용:
              <ul className='starbeat-notice-desc-depth3-group'>
                <li className='starbeat-notice-desc-depth3-list'>1) 스타비트를 구매한 뮤빗 계정 이메일</li>
                <li className='starbeat-notice-desc-depth3-list'>
                  2) 뮤빗 계정 로그인 타입 (마이페이지&gt;로그인된 계정에서 확인 가능합니다.)
                </li>
                <li className='starbeat-notice-desc-depth3-list'>3) 구매한 스타비트 상품명, 결제 가격</li>
                <li className='starbeat-notice-desc-depth3-list'>4) 해당 상품 결제 일시</li>
                <li className='starbeat-notice-desc-depth3-list'>5) 환불 사유</li>
              </ul>
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 정상적으로 환불 처리가 진행될 때까지 시간이 다소 걸릴 수 있는 점 참고 부탁드립니다. 단, 각호의 경우에는
              결제취소 처리가 불가능합니다.
              <ul className='starbeat-notice-desc-depth3-group'>
                <li className='starbeat-notice-desc-depth3-list'>
                  &#9312; 이벤트, 쿠폰, 보상 등 결제 수단이 무료로 지급된 경우
                </li>
                <li className='starbeat-notice-desc-depth3-list'>&#9313; 해당 기간 내에 사용내역이 있는 경우</li>
                <li className='starbeat-notice-desc-depth3-list'>
                  &#9314; 해당 결제 수단에 따른 결제취소 가능 기간을 경과한 경우
                </li>
                <li className='starbeat-notice-desc-depth3-list'>&#9315; 회원의 단순 과실일 경우</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
};

export default StarbeatNoticeKO;
